import React from "react";
import Navbar from "../navbars/Navbar";
import Section from "./Section";
import Slider from "./Slider";
import Footer from "../footer/Footer";

const MainHome = () => {
  return (
    <div>
      <Navbar />
      {/* <Slider /> */}

      <Section />
      {/* <Footer /> */}
    </div>
  );
};

export default MainHome;
